import React from 'react';
import { Table } from '@mantine/core';

import PaperSection from '../PaperSection';
import ManifestsItem from './Manifests.item';
import useManifestsTable from './useManifestsTable';
import { EmptyList } from '../EmptyList';

const ManifestsTable: React.FC = () => {
  const { loading, manifests, error } = useManifestsTable();
  return (
    <PaperSection loading={loading} title="Today's Manifests" error={error}>
      {manifests.length ? (
        <Table.ScrollContainer minWidth={800} scrollAreaProps={{ type: 'auto' }}>
          <Table aria-label="Today's Manifests">
            <Table.Thead>
              <Table.Tr>
                <Table.Th miw={200}>Restaurant Name</Table.Th>
                <Table.Th miw={80}>Version</Table.Th>
                <Table.Th miw={100}>Status</Table.Th>
                <Table.Th miw={160}>Manifest Time</Table.Th>
                <Table.Th miw={160}>Ready & Bagged</Table.Th>
                <Table.Th miw={160} />
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {manifests.map((item) => (
                <ManifestsItem key={`${item.manifestId}-${item.version}`} item={item} />
              ))}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      ) : (
        <EmptyList text="You don't have manifests for today" />
      )}
    </PaperSection>
  );
};

export default ManifestsTable;
